<template>
  <div class="box_form">
    <div class="modal_title">New Seated Box</div>
    <div class="modal_description">
      Configure your new box. You can change this any time
    </div>
    <ValidationObserver
      ref="create_box"
      slim
      v-slot="{ handleSubmit, reset }"
    >
      <form
        class="create_box"
        @submit.prevent="handleSubmit(submitBox)"
        @reset.prevent="reset"
        autocomplete="off"
      >
        <div class="form_fields">
          <div class="field_block">
            <ValidationProvider
              name="name"
              v-slot="{ errors }"
              slim
              rules="required"
            >
              <label :class="{ has_error: errors[0] }">
                <span class="field_name">Box Name</span>
                <input type="text" name="name" v-model="box.name" />
                <span class="error_message">{{ errors[0] ? "Required field" : "" }}</span>
              </label>
            </ValidationProvider>
          </div>
          <div class="field_block">
            <label>
              <span class="field_name">Seats</span>
              <input type="text" name="seats" v-model="box.seats" />
            </label>
          </div>
        </div>
        <span class="divider"></span>

        <div class="form_btns">
          <a class="secondary_btn" @click="$emit('closePopup')">Cancel</a>
          <button class="primary_btn" aria-label="add box">
            Add Box
          </button>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
export default {
  data() {
    return {
      box: {
        name: null,
        seats: null,
        rectW: 115,
        rectH: 115,
        rotation: 0,
      },
    };
  },
  methods: {
    submitBox() {
      this.$emit("submitBox", {
        type: "box",
        data: { ...this.box },
      });
    },
  },
};
</script>

<style></style>
